import * as React from 'react'

import { Hidden, spacing, Visible } from 'main/ui'
import { Column, ColumnsContainer, Container, GroupTitle } from './LinksSection.styles'
import { StyledLink, StyledNativeLink } from './styles'

function LinksSection() {
  return (
    <Container>
      <Visible lg xl>
        <div>
          <LocationsGroup />
        </div>
      </Visible>

      <div>
        <MainGroup />
        <Hidden lg xl>
          <div css={{ marginTop: spacing.majorScale(3) }}>
            <LocationsGroup />
          </div>
        </Hidden>
      </div>

      <div>
        <FollowUsGroup />

        <Hidden lg xl>
          <div css={{ marginTop: spacing.majorScale(3) }}>
            <ChildCareResourcesGroup />
          </div>
        </Hidden>
      </div>

      <Visible lg xl>
        <div>
          <ChildCareResourcesGroup />
        </div>
      </Visible>
    </Container>
  )
}

function MainGroup() {
  return (
    <React.Fragment>
      <GroupTitle>Wonderschool</GroupTitle>
      <ColumnsContainer>
        <Column>
          <div>
            <StyledNativeLink href="/corp/quality-and-safety">Safety and quality</StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/company">About us</StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/careers">Careers</StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/corp/press">Press</StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/contact">For business</StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="mailto:hello@wonderschool.com">Email us</StyledNativeLink>
          </div>
        </Column>
      </ColumnsContainer>
    </React.Fragment>
  )
}

function LocationsGroup() {
  return (
    <React.Fragment>
      <GroupTitle>Find your local Wonderschool</GroupTitle>
      <ColumnsContainer>
        <Column>
          <div>
            <StyledLink to="/ca/berkeley">Berkeley, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/irvine">Irvine, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/la-canada-flintridge">La Canada Flintridge, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/los-angeles">Los Angeles, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/oakland">Oakland, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/richmond">Richmond, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/san-francisco">San Francisco, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/san-jose">San Jose, CA</StyledLink>
          </div>
          <div>
            <StyledLink to="/ca/san-mateo">San Mateo, CA</StyledLink>
          </div>
        </Column>
        <Column>
          <div>
            <StyledLink to="/co/denver">Denver, CO</StyledLink>
          </div>
          <div>
            <StyledLink to="/nc/charlotte">Charlotte, NC</StyledLink>
          </div>
          <div>
            <StyledLink to="/ny/new-york">New York, NY</StyledLink>
          </div>
          <div>
            <StyledLink to="/ny/bronx">Bronx, NY</StyledLink>
          </div>
          <div>
            <StyledLink to="/ny/brooklyn">Brooklyn, NY</StyledLink>
          </div>
          <div>
            <StyledLink to="/tx/dallas">Dallas, TX</StyledLink>
          </div>
          <div>
            <StyledLink to="/tx/houston">Houston, TX</StyledLink>
          </div>
          <div>
            <StyledLink to="/va/richmond">Richmond, VA</StyledLink>
          </div>
          <div>
            <StyledNativeLink href="/locations">All Locations</StyledNativeLink>
          </div>
        </Column>
      </ColumnsContainer>
    </React.Fragment>
  )
}

function FollowUsGroup() {
  return (
    <React.Fragment>
      <GroupTitle>Follow us</GroupTitle>
      <ColumnsContainer>
        <Column>
          <div>
            <StyledNativeLink
              href="https://blog.wonderschool.com/articles/meet-parenthoods-wonderschools-online-community-of-parents"
              target="_blank"
            >
              Parent community
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink
              href="https://blog.wonderschool.com/categories/parents"
              target="_blank"
            >
              Parent resources
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink
              href="https://blog.wonderschool.com/categories/directors"
              target="_blank"
            >
              Director resources
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="https://blog.wonderschool.com/" target="_blank">
              Company blog
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="https://facebook.com/joinwonderschool" target="_blank">
              Facebook
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="https://instagram.com/wonderschools" target="_blank">
              Instagram
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="https://twitter.com/wonderschools" target="_blank">
              Twitter
            </StyledNativeLink>
          </div>
        </Column>
      </ColumnsContainer>
    </React.Fragment>
  )
}

function ChildCareResourcesGroup() {
  return (
    <React.Fragment>
      <GroupTitle>Child care resources</GroupTitle>
      <ColumnsContainer>
        <Column>
          <div>
            <StyledNativeLink href="/p/parent-resources/preschool-vs-daycare/">
              Preschool vs. daycare
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/p/parent-resources/what-age-is-preschool/">
              What age is preschool
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/p/parent-resources/compare-childcare-options-pros-cons/">
              Compare child care options
            </StyledNativeLink>
          </div>
          <div>
            <StyledNativeLink href="/p/parent-resources/what-is-play-based-learning/">
              Play based learning
            </StyledNativeLink>
          </div>
        </Column>
      </ColumnsContainer>
    </React.Fragment>
  )
}

export default LinksSection
